import { cn } from '@/lib/utils';

import { StatusTag } from './StatusTag';

/** 기능 불릿 — `comingSoon` 은 아직 제공하지 않는 기능("오픈 예정" 표시). 랜딩·결제 요금제 공용. */
export interface FeatureItem {
  label: string;
  comingSoon?: boolean;
}

/** 아직 제공하지 않는 기능 표시 태그. */
export function ComingSoonTag({ className }: { className?: string }) {
  return (
    <StatusTag tone="warning" className={cn('w-fit', className)}>
      오픈 예정
    </StatusTag>
  );
}
